<template>
  <div v-if="computedCompressedWarnings.length > 0">
    <div  class="announcements" role="alert">
      <a v-for="(warning, index) in computedCompressedWarnings" :key="index" :href="`#${warning.formId}`" :id="warning.formId" class="announcement _mbxs" :class="!warning.type ? '-warning' : `-${warning.type}`">
        <p>{{warning.text}}</p>
      </a>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    props: {
      warnings: Array
    },
    data() {
      return {
        compressables: [
          {
            regex: /(Effective date must be on or after) .* (\d+\/\d+\/\d+)/,
            transform: (matches, otherMatches) => {
              let latestDate = matches[2]
              otherMatches.forEach((otherMatch) => {
                const laterDate = otherMatch[2]
                if (moment(laterDate).isAfter(latestDate)) {
                  latestDate = laterDate
                }
              })
              return `Effective date must be on or after ${latestDate}`
            }
          }
        ]
      }
    },
    computed: {
      computedCompressedWarnings() {
        const otherCompressableMatches = {}
        const compressedWarnings = []
        const filteredWarnings = this.warnings.filter((warning) => {
          let compressed = false
          this.compressables.forEach((compressable, index) => {
            const compressionMatch = warning.text.match(compressable.regex)
            if (!compressionMatch || compressionMatch.length === 0) {
              return
            }

            const otherMatches = (otherCompressableMatches[index] = otherCompressableMatches[index] || [])
            otherMatches.push(compressionMatch)

            compressedWarnings[index] = ({
              ...warning,
              text: compressable.transform(compressionMatch, otherMatches)
            })

            if (!compressed) {
              compressed = true
            }
          })

          return !compressed
        })

        return [ ...filteredWarnings, ...compressedWarnings ]
      }
    }
  }
</script>
